import {
    Component,
    OnInit,
    EventEmitter,
    Output,
} from '@angular/core';

import { AppService } from '@services/app.service';
import { online } from '@/Interface/status';
import { Subject } from 'rxjs';
import { PlantsNew } from '@/Interface/Register';
import { Pdetails, PlantList, PlantStatusDDL } from '@/Interface/plants';
import { UtilityService } from '@services/utility.service';
import * as Highcharts from 'highcharts';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { debounceTime } from 'rxjs/operators';
import { convertToKarachiTimestamp } from '@/helpers/helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { StationsDropDown, StationYield } from '@/Interface/analysisEmi';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker/bs-daterangepicker.config';
import moment from 'moment';
import { PermissionsService } from '@services/permissions.service';
import { DEFAULT_PERMISSIONS } from '@/constants/constants';
@Component({
    selector: 'app-analysis-heat-map',
    templateUrl: './analysis-heat-map.component.html',
    styleUrls: ['./analysis-heat-map.component.scss']
})
export class AnalysisHeatMapComponent implements OnInit {
    stationList: StationYield[] = []
    sortColumn: string = 'plantName'; // Default sorting column
    sortOrder: 'asc' | 'desc' = null; // Default sorting order
    sortOrderPlantName: 'asc' | 'desc' | null = null;
    sortOrderCapacity: 'asc' | 'desc' | null = null;
    // detail: Plants[] = [];
    detail: PlantsNew[] = [];
    plantStatuslst: PlantStatusDDL[] = [];
    plantTypelst: PlantStatusDDL[] = [];
    searchElement = '';
    serialNumberArray: Array<number> = [];

    next_page: number;
    current_page: number;
    filtered_page: number;
    previous_page: number;
    last_page: number;
    total_pages: number;
    total_items: number;
    pageSize: number
    pageToGo: number = 1;
    public pageSizeControl = new FormControl(10);
    searchSubject: Subject<string> = new Subject();
    public pageRecordOptions = [
        { value: '10', label: '10' },
        { value: '25', label: '25' },
        { value: '50', label: '50' },
        { value: '100', label: '100' },
        { value: '200', label: '200' },
        // { value: '100', label: '100' }
    ];
    pdetail: Pdetails;
    myData: [] = [];

    Highcharts: typeof Highcharts = Highcharts;

    NormalizedPwowerGraph: any[] = [];
    AvailabilityPoweGraph: any[] = [];
    stationCdeList: any[] = [];
    plantNamesList: any[] = [];
    selectedPlantName: string
    normalizegraphList: any[] = [];
    NormalizedPower: any[] = [];
    AvailabilityPower: any[] = [];
    plantName: any;
    plantstatusfilter: number = 0;
    plantTypefilter: number = 0;
    state: online;
    dash: Pdetails;
    p: number = 1;
    tableLoader: boolean;
    message: boolean;
    private latestQueryParams: any = {};
    @Output() onSelected = new EventEmitter<any>();
    hasInitialized: boolean = false;
    // new
    regionList: any;
    contractTypeList: any;
    cititiesList: any;
    citiesByRegionList: any;
    heatBoxColumns: { index: number; date: string }[] = [];
    allPlantList: StationsDropDown;
    heatLegend = [
        { label: '0', color: '#F44326' },
        { label: '0-1', color: '#FF6D6D' },
        { label: '1-2', color: '#F57200' },
        { label: '2-3', color: '#FFD400' },
        { label: '3-4', color: '#DAC800' },
        { label: '4-5', color: '#23B762' },
        { label: '5-7', color: '#0C8A41' },
        { label: '7+', color: '#B3B3B3' }
    ];
    selectedRange: Date = new Date();
    datePickerConfig: Partial<BsDaterangepickerConfig> = {
        showWeekNumbers: false,
        dateInputFormat: 'MMMM YYYY', // Show only month and year in input
        minMode: 'month' // Restrict to month selection
    };
    // rangeInputFormat: 'MMM YYYY', // Month and Year format
    loader: boolean;
    permissions = { ...DEFAULT_PERMISSIONS };
    permissionsReady: boolean = false;
    constructor(
        private appservice: AppService,
        private _utilityService: UtilityService,
        private _datePipe: DatePipe,
        private modalService: NgbModal,
        private fb: FormBuilder,
        private toastr: ToastrService,
        private permService: PermissionsService,

    ) {
        this.onRangeChange(this.selectedRange)
    }
    ngOnInit(): void {
        Highcharts.setOptions({
            time: {
                timezone: 'Asia/Karachi'
            }
        });
        this.fillDropDown();
        this.initComponent();
        // this.Status();
        // this.dashboard();
        // this.getdashboardDetails();
        this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
            this.searchElement = searchTerm;
            this.updateQueryParams({ search: this.searchElement });
        });

        this.hasInitialized = false;
    }
    async initComponent() {
        this.loader = true
        await this.getComponentPermissions();

        if (this.permissions.canView) {
            this.getTableData();
        }
        setTimeout(() => {
            this.loader = false;
        }, 250);
    }

    async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
    get hasAnyActionPermission(): boolean {
        return (
            this.permissionsReady &&
            (this.permissions.canView ||
                this.permissions.canEdit ||
                this.permissions.canDelete)
        );
    }
    getHeatColor(value: number): string {
        if (value === 0) return '#F44326';
        if (value > 0 && value <= 1) return '#FF6D6D';
        if (value > 1 && value <= 2) return '#F57200';
        if (value > 2 && value <= 3) return '#FFD400';
        if (value > 3 && value <= 4) return '#DAC800';
        if (value > 4 && value <= 5) return '#23B762';
        if (value > 5 && value <= 7) return '#0C8A41';
        return '#B3B3B3';
    }
    getHeatClass(value: number): string {
        if (value === 0) return 'heat-0';
        if (value > 0 && value <= 1) return 'heat-1';
        if (value > 1 && value <= 2) return 'heat-2';
        if (value > 2 && value <= 3) return 'heat-3';
        if (value > 3 && value <= 4) return 'heat-4';
        if (value > 4 && value <= 5) return 'heat-5';
        if (value > 5 && value <= 7) return 'heat-6';
        return 'heat-default';
    }

    // front-end sorting
    onSort(event: any): void {
        const sortBy = event.sorts[0];
        // Assuming your data is an array of objects (this.ticketList), use Array.prototype.sort()
        this.detail.sort((a, b) => {
            const valueA = a.hasOwnProperty(sortBy.prop) ? a[sortBy.prop] : null;
            const valueB = b.hasOwnProperty(sortBy.prop) ? b[sortBy.prop] : null;

            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return sortBy.dir === 'asc' ? valueA - valueB : valueB - valueA;
            } else if (typeof valueA === 'string' && typeof valueB === 'string') {
                return sortBy.dir === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
            } else {
                return String(valueA).localeCompare(String(valueB));
            }
        });
    }

    private updateQueryParams(paramsToUpdate: any): void {
        this.latestQueryParams = {
            ...this.latestQueryParams,
            ...paramsToUpdate
        };

        if (this.latestQueryParams.page && (this.latestQueryParams.status && this.latestQueryParams.type && this.latestQueryParams.contract_type_id && this.latestQueryParams.region_id && this.latestQueryParams.city_id && this.latestQueryParams.station_codes && this.latestQueryParams.fromDate && this.latestQueryParams.toDate)) {
            this.latestQueryParams.page = paramsToUpdate.page
        }

        if (this.latestQueryParams.search === '') {
            this.latestQueryParams.search = null;
        }

        if (this.latestQueryParams.page === 1) {
            this.latestQueryParams.page = null;
        }

        if (this.latestQueryParams.size === 10) {
            this.latestQueryParams.size = null;
        }


        if (this.latestQueryParams.sort === null || this.latestQueryParams.column === null) {
            delete this.latestQueryParams.sort;
            delete this.latestQueryParams.column;
        }
        if (this.latestQueryParams.type === null) {
            delete this.latestQueryParams.type;
        }

        if (this.latestQueryParams.status === null) {
            delete this.latestQueryParams.status;
        }
        if (this.latestQueryParams.contract_type_id === null) {
            delete this.latestQueryParams.contract_type_id;
        }
        if (this.latestQueryParams.region_id === null) {
            delete this.latestQueryParams.region_id;
        }
        if (this.latestQueryParams.city_id === null) {
            delete this.latestQueryParams.city_id;
        }
        if (!this.latestQueryParams.fromDate && !this.latestQueryParams.toDate) {
            delete this.latestQueryParams.fromDate;
            delete this.latestQueryParams.toDate;
        }
        if (
            !this.latestQueryParams.station_codes ||
            this.latestQueryParams.station_codes.trim() === ''
        ) {
            delete this.latestQueryParams.station_codes;
        }
        if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
            this.latestQueryParams.size = paramsToUpdate.size || null;
            this.latestQueryParams.search = paramsToUpdate.search || null;
        }

        // Reset size to 1 when any filter or search is applied
        if (paramsToUpdate.search !== undefined ||
            paramsToUpdate.status !== undefined ||
            paramsToUpdate.type !== undefined ||
            paramsToUpdate.contract_type_id !== undefined ||
            paramsToUpdate.region_id !== undefined ||
            paramsToUpdate.city_id !== undefined ||
            paramsToUpdate.station_codes !== undefined ||
            paramsToUpdate.fromDate !== undefined ||
            paramsToUpdate.toDate !== undefined) {

            this.latestQueryParams.page = 1;
        }

        this.getTableData();

    }

    private getTableData(): void {
        const name = this.latestQueryParams['search'] || this.searchElement;

        const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;

        const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;

        const sort = this.latestQueryParams['sort'] || null;
        const column = this.latestQueryParams['column'] || null;

        const type = this.latestQueryParams['type'] || null;
        const status = this.latestQueryParams['status'] || null;
        const contractType = this.latestQueryParams['contract_type_id'] || null;
        const region = this.latestQueryParams['region_id'] || null;
        const city = this.latestQueryParams['city_id'] || null;
        const stationCodes = this.latestQueryParams['station_codes'] || null;
        const fromDate = this.latestQueryParams['fromDate'] || null;
        const toDate = this.latestQueryParams['toDate'] || null;

        this.getAllPlants(name, page, size, sort, column, type, status, contractType, region, city, stationCodes, fromDate, toDate);
    }


    getAllPlants(name: string, page: number, size: number, sort: string | null, column: string | null, type: string | null, status: string | null,
        contractType: number | null, region: number | null, city: number | null, stationCodes: number[] | null, fromDate?: string | null, toDate?: string | null): void {
        this.tableLoader = true;
        this.serialNumberArray = [];
        this._utilityService
            .getEMIHeatMap(name, page, size, sort, column, type, status, contractType, region, city, stationCodes, fromDate, toDate)
            .subscribe({
                next: (res: any) => {
                    if (res?.status === 200) {
                        this.stationList = res.data || [];
                        this.heatBoxColumns = this.stationList[0]?.yeild_data?.map((item, index) => ({
                            index: index + 1,
                            date: item.date
                        })) || [];

                        this.current_page = res.current_page;
                        this.next_page = res.next_page;
                        this.previous_page = res.previous_page;
                        this.total_pages = res.total_records;
                        this.total_items = res.total_records;

                        this.enablePagination();
                    }
                    if (res?.status === 400) {
                        this.stationList = [];
                    }
                    this.tableLoader = false;
                },
                error: err => {
                    this.stationList = [];
                    console.error('Failed to load plant data:', err);
                    this.tableLoader = false;
                }
            });
    }
    //  Sorting as query params (backend)
    sortPlants(column: string): void {
        if (this.sortColumn === column) {
            this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortColumn = column;
            this.sortOrder = 'asc';
        }

        let sortValue: string | null = null;
        let columnName: string;

        if (this.sortOrder === 'asc') {
            sortValue = '0';
        } else if (this.sortOrder === 'desc') {
            sortValue = '1';
        }

        if (column === 'plantName') {
            columnName = 'stationName';
            this.sortOrderPlantName = this.sortOrder;
            this.sortOrderCapacity = null;
        } else if (column === 'capacity') {
            columnName = column;
            this.sortOrderCapacity = this.sortOrder;
            this.sortOrderPlantName = null;
        }

        this.updateQueryParams({ sort: sortValue, column: columnName });
    }


    public searchData(event: Event): void {
        this.searchElement = (event.target as HTMLInputElement)?.value || '';
        this.searchSubject.next(this.searchElement);
    }

    goToPage(page: number): void {
        if (page >= 1 && page <= this.total_pages) {
            this.updateQueryParams({ page: page });
        }
    }

    navigatePage(direction: string): void {

        if (direction === 'prev' && this.current_page > 1) {
            this.goToPage(this.current_page - 1);
        } else if (direction === 'next' && this.next_page !== null) {
            this.goToPage(this.current_page + 1);
        }
    }
    // Add a method to navigate to the entered page
    navigateToPage(): void {
        if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
            this.goToPage(this.pageToGo);
        }
    }

    public changePageSize(): void {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.pageSize = this.pageSizeControl.value!;
        this.updateQueryParams({ size: this.pageSize })
    }

    getAvailabilityChartOption(AvailabilityChartList: any) {
        console.log('AvailabilityChartList', AvailabilityChartList)
        var NormalizedGraph = {
            chart: {
                type: 'area',
                margin: [0, 0, 0, 0], // Set the margin to [top, right, bottom, left]
            },
            title: {
                text: null,
            },
            xAxis: {
                type: 'datetime', // Specify type as datetime
                dateTimeLabelFormats: {
                    hour: '%I:%M %p',
                },
                title: {
                    text: 'Time', // Label for x-axis
                },
            },
            yAxis: {
                labels: {
                    enabled: false,
                },
                title: {
                    text: null,
                },
                visible: false, // Hide the yAxis
            },
            plotOptions: {
                area: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: false,
                },
            },
            credits: {
                enabled: false, // Disable the Highcharts credits, which include the watermark
            },
            tooltip: {
                style: {
                    fontSize: '9px', // Set the desired tooltip text size
                },
                padding: 2,
                formatter: function () {
                    return Highcharts.dateFormat('%I:%M %p', this.x) + '<br/>' + this.y + '%';
                },
            },
            series: [
                {
                    name: 'Percentage',
                    //   data: AvailabilityChartList.map(data => [data.timestamp.getTime(), data.percentage]), // Map timestamp to milliseconds
                    data: AvailabilityChartList.map(data => [
                        convertToKarachiTimestamp(data.timestamp),
                        data.percentage
                    ]),
                    color: '#AA4A56',
                    type: 'area', // to make bar graph again make its type: 'column'
                    fillOpacity: 0.3,
                    showInLegend: false,
                },
            ],
        };

        return NormalizedGraph;
    }
    getChartOption(graphValuesList) {
        var NormalizedGraph = {
            chart: {
                type: 'area',
                margin: [0, 0, 0, 0], // Set the margin to [top, right, bottom, left]
            },
            title: {
                text: null,
            },
            xAxis: {
                type: 'category', // Use category type for time values
                title: {
                    text: 'Time',
                },
                labels: {
                    style: {
                        fontSize: '10px', // Adjust label font size if needed
                    },
                },
            },
            yAxis: {
                labels: {
                    enabled: false,
                },
                title: {
                    text: null,
                },
                visible: false, // Hide the yAxis
            },
            plotOptions: {
                area: {
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: false,
                    lineWidth: 0, // Set the border width to 0 to hide borders
                },
            },
            credits: {
                enabled: false,
            },
            tooltip: {
                style: {
                    fontSize: '8px', // Set the desired tooltip text size
                },
                padding: 2, // Adjust the padding to reduce spacings
            },
            series: [
                {
                    name: 'Power',
                    data: graphValuesList,
                    type: 'area',
                    color: 'Orange',
                },
            ],
        };

        return NormalizedGraph;
    }


    fillDropDown() {
        this.plantStatuslst = [];
        this.plantStatuslst.push(new PlantStatusDDL(1, 'Offline'));
        this.plantStatuslst.push(new PlantStatusDDL(2, 'Faulty'));
        this.plantStatuslst.push(new PlantStatusDDL(3, 'Online'));

        this.plantTypelst.push(new PlantStatusDDL(1, 'Huawei'));
        this.plantTypelst.push(new PlantStatusDDL(2, 'GoodWe'));
        this.plantTypelst.push(new PlantStatusDDL(3, 'Deye'));

        this.dropDownInit()
    }

    Filterplants(filter: string) {
        ////debugger;
        this.tableLoader = true;

        this.appservice.FilteredPlantsdetails(filter).subscribe((res) => {
            if (res) {
                // debugger;
                // this.detail = res.data;
                this.detail = res.data.map((plant: any) => {
                    plant.capacity = plant.capacity.toFixed(2);
                    plant.specificYield = (plant.specificYield * 1000).toFixed(2);
                    plant.currentPower = plant.currentPower.toFixed(2);
                    plant.energyToday = plant.energyToday.toFixed(2);
                    return plant;
                });
                this.stationCdeList = res.stationCodes;
                this.current_page = res.current_page;
                if (res.next_page == null) {
                    this.next_page = res.last_page;
                }
                else {
                    this.next_page = res.next_page;
                }
                this.previous_page = res.previous_page;
                this.last_page = res.last_page;
                this.total_pages = res.total_pages;
                this.enablePagination();

                this.hasInitialized = false;
                this.tableLoader = false;
            }

        });
    }


    enablePagination() {
        const linkElement = document.getElementById('prevPage');

        if (this.previous_page === null) {
            linkElement.setAttribute('disabled', 'true');
            linkElement.style.pointerEvents = 'none';
            linkElement.style.color = 'gray'; // You can set the color to indicate it's disabled
            linkElement.addEventListener('click', (event) => {
                event.preventDefault(); // Prevent the default behavior (navigation)
            });
        } else {
            linkElement.removeAttribute('disabled');
            linkElement.style.pointerEvents = 'auto'; // Enable clicking
            linkElement.style.color = ''; // Reset the color to its default
            linkElement.removeEventListener('click', (event) => {
                event.preventDefault();
            });
        }
    }
    Status() {
        this.appservice.plantStatus().subscribe((res) => {
            this.state = res.data;
        });
    }
    // dashboard() {
    //     this.appservice.dashboard().subscribe((res) => {
    //         this.dash = res.data;
    //     });
    // }

    createfilter(): string {

        var filter = "";
        if (!(this.plantName === null || this.plantName == undefined)) {
            if (this.plantName !== "") {
                filter = filter + "search=" + this.plantName;
            }
        }
        if (this.filtered_page >= 0) {
            if (filter !== "") {
                filter = filter + '&';
            }
            filter = filter + "page=" + this.filtered_page;
        }

        if (this.plantstatusfilter > 0) {
            if (filter !== "") {
                filter = filter + '&';
            }
            filter = filter + "status=" + this.plantstatusfilter;
        }

        if (this.plantTypefilter > 0) {
            if (filter !== "") {
                filter = filter + '&';
            }
            filter = filter + "type=" + this.plantTypefilter;
        }

        return filter;
    }
    public selectPlants(plants: StationsDropDown[]): void {
        const stationCodes = plants.map(p => p.stationCode).join(',');
        const queryParams = { station_codes: stationCodes };
        console.log('Query Params:', queryParams);
        this.updateQueryParams(queryParams);
    }
    // public selectContractType(contractType: any[]) {
    //         if (contractType && contractType.length > 0) {
    //             const contractIds = contractType.map((contract: any) => contract.id);
    //             const formattedIds = `{${contractIds.join(',')}}`; // <-- This gives {14,15}
    //             this.updateQueryParams({ contract_type_id: formattedIds });
    //         } else {
    //             this.updateQueryParams({ contract_type_id: null });
    //         }
    //     }
    public selectContractType(contractType: any[] | null) {
        const id = contractType?.map(p => p.id).join(',') || '';
        this.updateQueryParams({ contract_type_id: id });
    }

    public selectRegion(region: any[] | null) {
        const id = region?.map(p => p.id).join(',') || '';
        this.updateQueryParams({ region_id: id });
    }

    public selectCity(city: any[] | null) {
        const id = city?.map(p => p.id).join(',') || '';
        this.updateQueryParams({ city_id: id });
    }
    selctPlantlistStatus(sourceId) {
        let statusQueryParam = null;
        if (sourceId === null || sourceId == undefined) {
            this.plantstatusfilter = 0;
        }
        else {
            this.plantstatusfilter = sourceId;
            statusQueryParam = sourceId; // new line added 
        }
        // this.Filterplants(this.createfilter());
        this.updateQueryParams({ status: statusQueryParam });
    }

    selctPlantlistType(sourceId) {
        //////debugger;
        let typeQueryParam = null;  // new line added 
        if (sourceId === null || sourceId == undefined) {
            this.plantTypefilter = 0;
        }
        else {
            this.plantTypefilter = sourceId;
            typeQueryParam = sourceId; // new line added 
        }

        // this.Filterplants(this.createfilter());   // previous function
        this.updateQueryParams({ type: typeQueryParam });  // new line added 

    }



    Pagination(pageNo: number) {
        if (pageNo >= 1 && pageNo <= this.total_pages) {
            this.filtered_page = pageNo;
            this.Filterplants(this.createfilter());
        }
    }

    Search() {
        if (this.plantName == '') {
            this.ngOnInit();
        } else {
            this.Filterplants(this.createfilter());
        }
    }

    key: string = 'capacity';
    reverse: boolean = false;
    sort(key: any) {
        this.key = key;
        this.reverse = !this.reverse;
    }


    // getdashboardDetails() {
    //     this.appservice.dashboard().subscribe((res) => {
    //         this.pdetail = res.data;
    //     });
    // }

    dropDownInit() {
        this.getContractType()
        this.getRegion()
        this.getCities()
        this.getPlantsDropDown()
    }
    getContractType() {
        this._utilityService.getContractTypeDropDown().subscribe((res) => {
            if (res) {
                this.contractTypeList = res;
            }
        });
    }
    getRegion() {
        this._utilityService.getRegionDropDownList().subscribe((res) => {
            if (res) {
                this.regionList = res;
            }
        });
    }
    getCities() {
        this._utilityService.getCitiesDropDown().subscribe((res) => {
            if (res) {
                this.cititiesList = res;
            }
        });
    }
    getCitiesByRegion(region: any) {
        const id = region?.id || null;
        if (id) {
            this._utilityService.getCitiesByRegionDropDown(id).subscribe((res) => {
                if (res) {
                    this.citiesByRegionList = res;
                    console.log('citiesByRegionList Item', this.regionList)
                }
            });
        }
        else {
            this.citiesByRegionList = null
        }
    }
    getPlantsDropDown() {
        this._utilityService.getStationsDropDown().subscribe((res) => {
            if (res) {
                this.allPlantList = res.data;
            }
        });
    }
    // onRangeChange(dates: Date[]): void {
    //     if (dates?.length === 2) {
    //         const [start, end] = dates;
    //         const diffInMs = Math.abs(end.getTime() - start.getTime());
    //         const diffInDays = diffInMs / (1000 * 60 * 60 * 24) + 1; // include both start & end

    //         if (diffInDays > 31) {
    //             this.toastr.warning('Please select a date range of 31 days or less.');
    //             this.selectedRange = null as any;

    //             setTimeout(() => {
    //                 this.selectedRange = [];
    //             });
    //         }

    //         this.selectedRange = dates;

    //         const formattedFromDate = moment(start).format('YYYY-MM-DD');
    //         const formattedToDate = moment(end).format('YYYY-MM-DD');
    //         this.updateQueryParams({
    //             fromDate: formattedFromDate,
    //             toDate: formattedToDate
    //         });
    //     }
    //     else {
    //         this.updateQueryParams({
    //             fromDate: null,
    //             toDate: null
    //         });
    //     }
    // }
    onRangeChange(date: Date): void {
        if (date) {
            const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
            const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            this.selectedRange = date; // Store the selected month only

            const formattedFromDate = moment(startOfMonth).format('YYYY-MM-DD');
            const formattedToDate = moment(endOfMonth).format('YYYY-MM-DD');

            this.updateQueryParams({
                fromDate: formattedFromDate,
                toDate: formattedToDate
            });
        } else {
            this.updateQueryParams({
                fromDate: null,
                toDate: null
            });
        }
    }



    clearDateRange(): void {
        if (this.selectedRange) {
            this.selectedRange = null
            this.updateQueryParams({ fromDate: null, toDate: null })
        }
    }
}
